import { IconPaths } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from 'app/components'
import { ProfissionalDeSaudeModal } from '../modal/ProfissionalDeSaudeModal'

export const ProfissionalDeSaudeListToolbar = () => {
  const { showModal } = useModal()
  const { t } = useT()

  const openModal = () =>
    showModal({
      title: 'Criar Profissional de Saúde',
      content: <ProfissionalDeSaudeModal />,
    })

  return (
    <Button className='btn-primary' icon={IconPaths.Add} onClick={openModal}>
      {t('common.add')}
    </Button>
  )
}
